var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "payment-plan-detail" }, [
    _c("div", { staticClass: "payment-top-area" }, [
      _c("div", { staticClass: "payment-tag-holder" }, [
        _vm.isCurrent
          ? _c(
              "span",
              { staticClass: "payment-tag", class: _vm.status?.toLowerCase() },
              [_vm._v("Current")]
            )
          : _vm._e(),
        _vm.showPreferred
          ? _c(
              "span",
              {
                staticClass: "payment-tag payment-preferred",
                class: _vm.status?.toLowerCase(),
              },
              [_vm._v("Preferred")]
            )
          : _vm._e(),
      ]),
      _c("strong", { staticClass: "payment-plan-name" }, [
        _vm._v(_vm._s(_vm.planName)),
      ]),
      _c("strong", { staticClass: "payment-plan-price" }, [
        _vm._v(_vm._s(`$${_vm.price}/mo`)),
      ]),
      _c("p", [_vm._v(_vm._s(_vm.description))]),
    ]),
    _c(
      "div",
      { staticClass: "payment-bottom-area" },
      [
        _c("ul", { staticClass: "payment-plan-list" }, [
          _c("li", [
            _c(
              "span",
              { staticClass: "payment-plan-icon" },
              [_c("InviteManagerIcon")],
              1
            ),
            _vm._v(
              " " +
                _vm._s(
                  _vm.planName === "Starter"
                    ? "Invite 1 Manager"
                    : _vm.planName === "Growth"
                    ? "Invite up to 5 Managers"
                    : _vm.planName === "Premium" && "Invite up to 20 Managers"
                ) +
                " "
            ),
          ]),
          _c("li", [
            _c(
              "span",
              { staticClass: "payment-plan-icon" },
              [_c("InviteResourceIcon")],
              1
            ),
            _vm._v("Invite unlimited Resources "),
          ]),
        ]),
        _c(
          "UiButton",
          {
            staticClass: "button-yellow",
            attrs: {
              disabled:
                (_vm.subcription?.subscription_plan_id === _vm.id ||
                  _vm.isPlanBefore) &&
                !_vm.subcription?.cancel_at_period_end,
            },
            on: { click: _vm.handleUpgrade },
          },
          [
            _vm._v(
              " " +
                _vm._s(
                  _vm.subcription?.subscription_plan_id === _vm.id &&
                    _vm.subcription?.cancel_at_period_end
                    ? "Activate"
                    : "Upgrade"
                ) +
                " "
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }